import { type InferType, object, string } from 'yup';

const CONSUMER_EMAIL_DOMAINS = [
  'aol.com',
  'comcast.net',
  'gmail.com',
  'gmail.co',
  'gmail.to',
  'gmx.com',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'mac.com',
  'mail.ck',
  'mail.com',
  'mailbird.com',
  'me.com',
  'msn.com',
  'mymail.com',
  'outlook.com',
  'protonmail.com',
  'postbox.com',
  'rocketmail.com',
  'sbcglobal.net',
  'taskmonk.ai',
  'test.com',
  'thunderbird.com',
  'turtlewig.com',
  'zoho.com',
  'yahoo.com',
  'yandex.mail',
] as const;

const GENERIC_INBOX_LOCAL_PARTS = new Set(['info', 'hello']);
const BUSINESS_EMAIL_ERROR = 'Please enter a business email';
const PERSONAL_BUSINESS_EMAIL_ERROR = 'Please enter a personal business email';

const getEmailDomain = (value: string) => value.toLowerCase().split('@')[1];
const getEmailLocalPart = (value: string) => value.toLowerCase().split('@')[0];

const isConsumerEmailDomain = (domain: string) =>
  CONSUMER_EMAIL_DOMAINS.some((consumerDomain) => domain === consumerDomain || domain.startsWith(`${consumerDomain}.`));

const isBusinessEmail = (value?: string) => {
  if (!value) {
    return true;
  }

  const domain = getEmailDomain(value);

  return !domain || !isConsumerEmailDomain(domain);
};

const isPersonalBusinessEmail = (value?: string) => {
  if (!value) {
    return true;
  }

  return !GENERIC_INBOX_LOCAL_PARTS.has(getEmailLocalPart(value));
};

export const DemoFormValidationSchema = object({
  firstName: string().default('').required('First name is required'),
  lastName: string().default('').required('Last name is required'),
  email: string()
    .email()
    .test('business-email', BUSINESS_EMAIL_ERROR, isBusinessEmail)
    .test('personal-business-email', PERSONAL_BUSINESS_EMAIL_ERROR, isPersonalBusinessEmail)
    .required('Email address is required')
    .default(''),
  company_size: string().default('').required('Company Size is required'),
  phone: string().default('').required('Phone number is required'),
  message: string().default(''),
});

export type DemoFormInput = InferType<typeof DemoFormValidationSchema>;
